import {
  ChatBubbleLeftRightIcon,
  CreditCardIcon,
  InformationCircleIcon,
  TruckIcon,
  UserIcon,
  UserPlusIcon,
} from '@heroicons/react/20/solid';

export const profileNavigation = [
  { id: 1, name: 'Profile', to: '/profile', icon: UserIcon },
  {
    id: 2,
    name: 'Support',
    to: 'https://www.retainerclub.com/support',
    icon: InformationCircleIcon,
  },
];

export const mobileProfileNavigation = [
  { id: 1, name: 'Profile', to: '/profile', icon: UserIcon },
  {
    id: 2,
    name: 'Payment Methods',
    to: '/payment-methods',
    icon: CreditCardIcon,
  },
  { id: 3, name: 'Family', to: '/my-family', icon: UserPlusIcon },
  { id: 4, name: 'Address Book', to: '/addresses', icon: TruckIcon },
  {
    id: 5,
    name: 'Communication Preferences',
    to: '/communication-preferences',
    icon: ChatBubbleLeftRightIcon,
  },
];
